import React from 'react';

export function SubmissaoDados({ modalData }) {
  return (
    <div>
      <div>
        <span>CNES</span>
        <p>{modalData && modalData.cnes}</p>
      </div>

      <div>
        <span>E-mail</span>
        <p>{modalData && modalData.email}</p>
      </div>

      <div>
        <span>Período</span>
        <p>{modalData && modalData.periodo}</p>
      </div>
    </div>
  );
}
